// ############################################################
// Copyright (C) 2021 by Gamify Software Inc - All Rights Reserved
// You may NOT distribute or modify this code without the expressed
// written consent of Gamify Software Inc.
// #############################################################
//
// SelectFromList
//

import { useState, useEffect } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import gql from 'graphql-tag';
import React, { API } from 'aws-amplify';

export default function SelectCircleOrPerson(props) {
  // console.log('!!SelectCircleOrPerson: ', props);
  const [itemList, setItemList] = useState([]);

  async function fetchCircles(ourSearchString) {
    // console.log('fetchCircles: ', ourSearchString);

    let filteredAssigneeList = [];
    if (props.pickCircles) {
      let filter = '{';
      filter += 'name: {wildcard: $searchString},';
      filter += 'orgID: {eq: $orgID},';
      filter += ' isDeleted: {eq: false}';
      if (props.hideCircleLevels !== undefined) {
        for (const circleLevelID of props.hideCircleLevels) {
          filter += ', levelID: {ne: "' + circleLevelID + '"}';
        }
      }

      if (
        !global.me.isAdmin &&
        (props.useCirclesList || props.useChildCirclesList)
      ) {
        //
        //  If the user is looking for all deals and they're NOT an admin, filter so that they see only the deals
        //  for the teams that they're in
        //
        filter += ', or: [';
        let first = true;

        if (props.useCirclesList) {
          for (const circleID of global.me.myCircles) {
            if (!first) {
              filter += ',';
            }
            filter += '{id: {eq: "' + circleID + '"}}';
            first = false;
          }
        }

        if (props.useChildCirclesList) {
          //
          //  Include all the circles under the user
          //
          for (const circleID of global.me.myChildCircles) {
            if (circleID !== global.me.leagueID) {
              //
              //  Allow the user to see all leads for any of their teams EXCEPT for their
              //  league.  This allows us to group people into leagues without allowing everyone
              //  in the same league to see everyone else's leads
              //
              if (!first) {
                filter += ',';
              }
              filter += '{id: {eq: "' + circleID + '"}}';
              first = false;
            }
          }
        }
        filter += ']';
      }
      filter += '}';

      // console.log('SelectCircle filter:', filter);
      const myQuery = gql`
        query MyQuery($orgID: ID!, $searchString: String!, $userID: ID!) {
          searchCircles(
            filter: ${filter},
            limit: 100,
            sort: { direction: asc, field: name })

            {
            items {
              id
              name
              users(filter: {id: {eq: $userID}}) {
                items {
                  id
                  userID
                  status
                  memberType
                }
              }
            }
            nextToken
          }
        }`;
      const mySearchString = ourSearchString + '*';

      const circleData = await API.graphql({
        query: myQuery,
        variables: {
          orgID: global.me.orgID,
          searchString: mySearchString,
          userID: global.me.id,
        },
      });
      // console.log('---circleData: ', circleData);
      const circles = circleData.data.searchCircles.items;
      // console.log('---circles: ', circles);

      const assigneeList = [];
      let userID = global.me.id;
      if (props.userID !== undefined) {
        // console.log ("setting userID to props");
        userID = props.userID;
      }

      for (const circle of circles) {
        // console.log ("circle.name", circle.name);
        // console.log('circle.id: ', circle.id);
        if (circle.id === global.me.orgID && !props.allowAllCircle) {
          continue;
        }
        // const inheritedCircleAdmin = true;
        const inheritedCircleAdmin = global.me.myChildCircles.includes(
          circle.id
        );
        // console.log ("inheritedCircleAdmin: ", inheritedCircleAdmin?"True":"False");
        let userHasRecord = false;
        // console.log ("global.me.myChildCircles: ", global.me.myChildCircles);
        //
        //  The user is approved if they're the admin, an inherited admin, or we're not checking permissions
        //
        let userApproved =
          global.me.isAdmin ||
          inheritedCircleAdmin ||
          !props.checkCreatePermissions;

        for (const user of circle.users.items) {
          //
          //  If the user ia attached to this circle, the user is an admin, or the user inherits admin to this cicle,
          //  by default we're approved
          //
          if (
            user.userID === userID ||
            global.me.isAdmin ||
            inheritedCircleAdmin
          ) {
            if (user.status === 'approved' || user.status === 'accepted') {
              userApproved = true;
              if (
                props.checkCreatePermissions &&
                user.memberType === 'member' &&
                !global.me.isAdmin &&
                !inheritedCircleAdmin
              ) {
                //
                // Members cannot create stuff using this circle, so do not approve them
                //
                // console.log('User rejected');
                userApproved = false;
                break;
              }
            }
            if (user.userID === userID) {
              userHasRecord = true;
            }
          }
          if (props.showAll) {
            userApproved = true;
          }
          // console.log(
          //   'props.checkCreatePermissions: ',
          //   props.checkCreatePermissions
          // );
          // console.log('user.memberType: ', user.memberType);
        }
        // console.log('user approved:', userApproved);
        // console.log('user has record:', userHasRecord);
        if (userApproved && props.skipCirclesUserBelongsTo === undefined) {
          // console.log('case 1');
          assigneeList[assigneeList.length] = {
            name: circle.name,
            id: circle.id,
            value: circle.id,
            label: circle.name,
            type: 'circle',
          };
        }
        if (userApproved && props.skipCirclesUserBelongsTo !== undefined) {
          // console.log('case 2');
          if (!userHasRecord) {
            assigneeList[assigneeList.length] = {
              name: circle.name,
              id: circle.id,
              value: circle.id,
              label: circle.name,
              type: 'circle',
            };
          }
        }
      }
      // console.log('!!!assigneeList: ', assigneeList);

      filteredAssigneeList = assigneeList;
      if (props.hideAssigned !== undefined) {
        filteredAssigneeList = [];

        for (const item of assigneeList) {
          if (!props.hideAssigned.includes(item.id)) {
            filteredAssigneeList[filteredAssigneeList.length] = item;
          }
        }
      }
      // console.log('!!!filteredAssigneeList: ', filteredAssigneeList);

      // for (let item of filteredAssigneeList) {
      // console.log("**item ", item);
      //   if (item.id == props.value) {
      //     if (searchString != item.name) {
      // console.log("setting name");
      //       setSearchString(item.name);
      //     }
      //   }
      //   if (filteredAssigneeList.length == 1 && searchString != item.name && !props.noAutoSelect) {
      //     //
      //     //  If there is only one circle in our list, select it by default
      //     //
      //     setSearchString(item.name);
      //     props.fieldSetter(item.id, item.name, searchString)
      //   }
      // }
    }

    if (props.pickUsers) {
      // console.log('!!!pickUsers!!!!');
      // console.log('filteredAssigneeList: ', filteredAssigneeList);

      const myPersonQuery = gql`
        query MyQuery($orgID: ID!, $searchString: String!) {
          searchUsers(
            filter: { name: { wildcard: $searchString }, orgID: { eq: $orgID } }
            limit: 100
            sort: { direction: asc, field: name }
          ) {
            items {
              id
              name
              status
            }
            nextToken
          }
        }
      `;
      const mySearchString = ourSearchString + '*';
      const userData = await API.graphql({
        query: myPersonQuery,
        variables: { orgID: global.me.orgID, searchString: mySearchString },
      });
      // console.log('userData: ', userData);
      const users = userData.data.searchUsers.items;

      const personAssigneeList = [];
      for (const user of users) {
        // console.log('!!!user: ', user);
        if (user.status === 'active') {
          personAssigneeList[personAssigneeList.length] = {
            value: user.id,
            label: user.name,
            type: 'user',
          };
        }
      }

      if (props.hideAssigned !== undefined) {
        for (const item of personAssigneeList) {
          if (!props.hideAssigned.includes(item.id)) {
            filteredAssigneeList[filteredAssigneeList.length] = item;
          }
        }
      } else {
        for (const item of personAssigneeList) {
          filteredAssigneeList[filteredAssigneeList.length] = item;
        }
      }
    }

    let sortedAssigneeList = filteredAssigneeList;
    if (props.pickUsers && props.pickCircles) {
      //
      //  sort the combined list
      //
      sortedAssigneeList = filteredAssigneeList.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0;
      });
    }
    if (props.allOption) {
      sortedAssigneeList.unshift({
        label: 'All ' + global.appSettings.labels.circle.plural,
        value: 'all',
        name: 'All ' + global.appSettings.labels.circle.plural,
        id: 'all',
      });
    }
    if (sortedAssigneeList.length === 0) {
      sortedAssigneeList[0] = {
        label: 'No Items Found',
        value: '--none--',
        name: 'No Items Found',
        id: '--none--',
      };
    }
    setItemList(sortedAssigneeList);
  }

  // if (lastUpdate != props.update) {
  // console.log("***HERE***")
  //   // setSearchString("");
  //   fetchCircles("");
  //   setLastUpdate(props.update);
  // }
  useEffect(() => {
    fetchCircles('');
  }, []);

  // if (itemValue != props.value) {
  //   setItemValue(props.value);
  // }

  // console.log('**update: ', props.update);

  // let label = "";
  // if (props.pickUsers && props.pickCircles) {
  //   label = 'Select a ' + global.appSettings.labels.person.proper + ' or a ' + global.appSettings.labels.circle.proper;
  // } else if (props.pickUsers) {
  //   label = 'Select a ' + global.appSettings.labels.person.proper;
  // } else {
  //   label = 'Select a ' + global.appSettings.labels.circle.proper;
  // }
  let itemLabel = '';
  for (const item of itemList) {
    if (item.id === props.value) {
      itemLabel = item.label;
      break;
    }
  }
  // console.log('!!itemLabel: ', itemLabel);
  // console.log('!!itemList: ', itemList);

  return (
    <Box>
      <>
        {itemList.length > 0 && (
          <Autocomplete
            classes={{ inputRoot: 'scorecard-dropdown-box' }}
            sx={{ width: 400 }}
            onInputChange={(event, val) => {
              fetchCircles(val);
            }}
            onChange={(event, val) => {
              // console.log('!!val: ', val);
              props.fieldSetter(val.value, val.label, val.type);
            }}
            options={itemList}
            defaultValue={itemLabel}
            renderInput={(params) => <TextField {...params} />}
          />
        )}
      </>
    </Box>
  );
}
